import React from "react";
import { GreenButton } from "components/Buttons/buttonsStyles";
import BasedModal from "components/BaseModalComponents/BasedModal";
import { ConfigFileItem } from "store/reducers/SettingsSlice";
import { Tooltip } from "antd";

interface AddConfigTypeModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    onChoose: (code: string, is_horizontal?: boolean) => void;
    configFilesList: ConfigFileItem[];
}

const AddConfigTypeModal: React.FC<AddConfigTypeModalProps> = ({
    isOpen,
    onRequestClose,
    onChoose,
    configFilesList,
}) => {
    return (
        <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <div
                style={{
                    padding: "24px",
                    background: "white",
                    borderRadius: "10px",
                    minWidth: "360px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                }}
            >
                <h3 style={{ margin: 0 }}>Выберите тип конфигурации</h3>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "12px",
                    }}
                >
                    {configFilesList.map((cfg) => {
                        if (cfg.is_uniq_ui) {
                            return (
                                <React.Fragment key={cfg.name}>
                                    <GreenButton
                                        onClick={() => {
                                            onChoose(cfg.name, false);
                                            onRequestClose();
                                        }}
                                        style={{
                                            cursor: "pointer",
                                        }}
                                    >
                                        {cfg.name}
                                    </GreenButton>
                                    <GreenButton
                                        onClick={() => {
                                            onChoose(cfg.name, true);
                                            onRequestClose();
                                        }}
                                        style={{
                                            cursor: "pointer",
                                        }}
                                    >
                                        {cfg.name} (гориз.)
                                    </GreenButton>
                                </React.Fragment>
                            );
                        }

                        return (
                            <Tooltip
                                key={cfg.name}
                                title={cfg.description || cfg.name}
                                placement="top"
                            >
                                <GreenButton
                                    onClick={() => {
                                        onChoose(cfg.name, false);
                                        onRequestClose();
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    {cfg.name}
                                </GreenButton>
                            </Tooltip>
                        );
                    })}
                </div>

                <GreenButton onClick={onRequestClose}>Отмена</GreenButton>
            </div>
        </BasedModal>
    );
};

export default AddConfigTypeModal;
